<template>
  <div :class="'notification ' + type">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "is-light",
    },
  },
};
</script>

